import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CalibrationDelivery_Interface } from 'src/app/Interface/CalibrationDelivery_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CalibrationDeliveryService {

  constructor(private http: HttpClient) { }



  GetRecord(
    startDate: String,
    endDate: String,
    customer: String,
    SubmitPeriodDate: String,
    Token: String): Observable<Array<CalibrationDelivery_Interface>> {
    return this.http.get(environment.BaseUrl
      + "Daro/CalibrationDelivery?token=" + Token
      + "&startDate=" + startDate
      + "&endDate=" + endDate
      + "&CustomerName=" + customer
      + "&SubmitPeriodDate=" + SubmitPeriodDate
    ).pipe(
      map(data => {
        return data as Array<CalibrationDelivery_Interface>
      })
    )
  }


  GetInfobyQR(Token: String,customer_id: number, qr: String): Observable<General_Interface> {
    return this.http.get(environment.BaseUrl + "Daro/CalibrationDelivery/GetInfobyQR?token=" + Token
    + "&qr=" + qr
    + "&customer_id=" + customer_id).pipe(
      map(data => {
        return data as General_Interface
      })
    )
  }


  SubmitDelivery(code: Array<string>,
    customer_id: number,
    inperson: boolean,
    inperson_type: number,
    code_rahgiri: String,
    tarikh_tahvil: String,
    karshnas_masol_id: number,
    inpersonName: String,
    inpersonPhone: String,
    inpersonDsc: String,
    inpersonCodeMeli: String,
    Token: String): Observable<Array<General_Interface>> {
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      customer_id: customer_id,
      inperson: inperson,
      inperson_type: inperson_type,
      code_rahgiri: code_rahgiri,
      tarikh_tahvil: tarikh_tahvil,
      karshnas_masol_id: karshnas_masol_id,
      Token: Token,
      code: code,
      inpersonName: inpersonName,
      inpersonPhone: inpersonPhone,
      inpersonDsc: inpersonDsc,
      inpersonCodeMeli: inpersonCodeMeli+'',
    }


    return this.http.post(environment.BaseUrl + "Daro/CalibrationDelivery/SubmitDelivery", body, { headers }).pipe(
      map(data => {
        return data as Array<General_Interface>
      })
    )

  }

  GetSingle(Token: String,id: number): Observable<any> {
    return this.http.get(environment.BaseUrl + "Daro/CalibrationDelivery/GetSingle?Token=" + Token
    + "&id=" + id).pipe(
      map(data => {
        return data as any
      })
    )
  }


}
